import { downloadPdf, printPdf } from "./documentTemplate";

/**
   * Genereate a PDF and perform the requested action
   * @param  {object} section Redux store section for the Assessment
   * @param  {string} action  Flag for printing/downloading PDF
   */
const generatePdf = (section, action, fileName) => {
  switch (action) {
    case "print":
      printPdf(section);
      break;
    case "download":
      downloadPdf(section, fileName);
      break;
    default:
      console.warn(
        `Invalid PDF Generation action specified: '${action}' must be either 'print' or 'download'`
      );
      break;
  }
};

export default generatePdf;



// WEBPACK FOOTER //
// ./src/common/pdf/generatePdf.js